export default {"src":"/_next/static/media/homepage-linkedin-footer-icon-desktop-white.8255193b.svg","height":35,"width":36,"blurWidth":0,"blurHeight":0};